import { LocationAlias } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const locationAliasTag = "LocationAlias";

export const locationAliasApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocationAliases: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params) {
          const { filters, pagination } = params as any;

          if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                searchParams.append(key, String(value));
              }
            });
          }

          if (pagination) {
            Object.entries(pagination).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
              }
            });
          }
        }

        const queryString = searchParams.toString();
        return `/gw/location-aliases${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [locationAliasTag],
    }),
    createLocationAlias: builder.mutation({
      query: (payload: LocationAlias) => ({
        url: "/gw/location-aliases",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [locationAliasTag],
    }),
    updateLocationAlias: builder.mutation({
      query: ({ id, ...payload }: LocationAlias) => ({
        url: `/gw/location-aliases/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [locationAliasTag],
    }),
    deleteLocationAlias: builder.mutation({
      query: (id: number) => ({
        url: `/gw/location-aliases/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [locationAliasTag],
    }),
  }),
});

export const {
  useGetLocationAliasesQuery,
  useCreateLocationAliasMutation,
  useUpdateLocationAliasMutation,
  useDeleteLocationAliasMutation,
} = locationAliasApi;
